<template>
  <div style='padding:0 52px'>
    <div>{{ $t('integration.level_alarm') }}</div>
    <el-divider></el-divider>
    <div class='levelPage' v-if='levelContent.length > 0'>
      <!-- 层级区域 -->
      <div class='leftList'>
        <ul>
          <li @click='handleLevelFn(item, index)' v-for='(item, index) in levelContent' :key='item.id'
              :class="index === active ? 'active' : ''" style='border-radius:2px'>
            {{ item.name }}
          </li>
        </ul>
      </div>
      <!-- 层级内容 -->
      <div class='rightContent'>
        <div class='mb15'>
          <span>
              {{ levelContent[active].name }}
          </span>
        </div>
        <!-- 层级延迟 -->
        <div class='levelDelay mb15'>
          <div v-for='item in levelContent[active].delayData' :key='item.id' class='uk-margin-small-right'
               style='border-radius:2px'>
            <span style='border-radius:2px 0 0 2px'>{{ item.type | filterFn }}</span>
            <span class='abDelay'>{{ item.delayNum }}</span>
            <span style='border-radius:0 2px 2px 0'>{{ item.unit | unitFilter }}{{ $t('alarm.alarm') }}</span>
          </div>
        </div>
        <!-- 延迟报警对象 -->
        <div class='mb15'>{{ $t('alarm.alarm_object') }}</div>
        <el-table stripe ref='multipleTable' :data='levelContent[active].alarmObject' tooltip-effect='dark'
                  style='width: 100%' :show-header='false'>
          <el-table-column prop='userId' show-overflow-tooltip>
            <template #default='{ row }'>
              <i class='el-icon-message' :class="startFn(row.alarmWay, '0')" :title="titleFn('0')"></i>
              <i class='el-icon-chat-dot-round' :class="startFn(row.alarmWay, '1')" :title="titleFn('1')"></i>
              <i class='el-icon-microphone' :class="startFn(row.alarmWay, '2')" :title="titleFn('2')"></i>
              <span>
                  {{ row.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop='phone' show-overflow-tooltip />
          <el-table-column prop='email' show-overflow-tooltip />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['LevelContentArray', 'sceneId'],
  filters: {
    filterFn (value) {
      switch (String(value)) {
        case '0': {
          return $t('public.ex_conn')
        }
        case '1': {
          return $t('public.ex_data')
        }
        case '2': {
          return $t('public.ex_power')
        }
        default:
          break
      }
    },
    unitFilter (num) {
      return num === 0 ? $t('public.second') : num === 1 ? $t('public.minute') : $t('public.hour')
    }
  },
  watch: {
    LevelContentArray (newVal) {
      const array = JSON.parse(JSON.stringify(newVal))
      this.active = 0
      this.levelContent = array.map(item => {
        item.delayData = JSON.parse(item.delayData)
        item.alarmObject = JSON.parse(item.alarmObject)
        return item
      })
    },
    sceneId (newVal) {
    }
  },
  data () {
    return {
      active: 0,
      delay_data: [],
      alarm_object: [],
      iconArray: [
        {
          id: '0',
          icon: 'el-icon-message',
          label: $t('alarm.alarm_mail')
        },
        {
          id: '1',
          icon: 'el-icon-chat-dot-round',
          label: $t('alarm.alarm_msg')
        },
        {
          id: '2',
          icon: 'el-icon-microphone',
          label: $t('alarm.alarm_phone')
        }
      ],
      levelContent: [],
      levelName: ''
    }
  },
  methods: {
    handleLevelFn (item, index) {
      this.active = index
      this.levelName = item.name
    },
    startFn (str, num) {
      if (!str) return
      const array = str.split(',')
      return array.includes(num) ? 'orange' : ''
    },
    titleFn (num) {
      let str = ''
      for (const item of this.iconArray) {
        if (item.id === num) {
          str = item.label
          break
        }
      }
      return str
    }
  }
}
</script>

<style lang='scss' scoped>
.levelPage {
  display: flex;
}

.leftList {
  width: 200px;
  border: 1px solid #ccc;
  padding: 5px;
  box-sizing: border-box;

  ul {
    max-height: 400px;
    width: 100%;
    overflow: auto;

    li {
      width: 100%;
      border-radius: 2px;
      margin: 5px 0;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      text-align: center;
      border: 1px solid #ccc;
      box-sizing: border-box;
      cursor: pointer;
    }

    .active {
      color: #fff;
      font-weight: bold;
      background-color: var(--primary-color);
    }
  }
}

.rightContent {
  flex: 1;
  padding: 0 15px;
  box-sizing: border-box;

  .mb15 {
    margin-bottom: 15px;
    font-size: 14px;
  }

  .levelDelay {
    display: flex;
    border-radius: 2px;

    span {
      display: inline-block;
      height: 30px;
      padding: 5px;
      line-height: 20px;
      font-size: 14px;
      box-sizing: border-box;
      border: 1px solid var(--primary-color);
      background-color: var(--primary-color);
      color: #fff;
    }

    .abDelay {
      background-color: #fff;
      color: var(--primary-color);
    }
  }

  i {
    margin-right: 5px;
    cursor: pointer;
    font-size: 14px;
  }

  .orange {
    color: orange;
  }
}

.el-divider {
  margin: 10px 0;
}
</style>
